import React, { useEffect, useState } from "react";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Style from "./StoreList.module.css";
import { cal_dis } from "../../Utils/Helper/Helper";

const StoreList = (props) => {
  const dataList=[...props.data]
  const userLat=localStorage.getItem('userLat')
  const userLon=localStorage.getItem('userLon')
  const faildAddress=!!userLat
  let SpliceChecker = null; 

  dataList.forEach(element=>{
    element.distance=cal_dis([element.lat,element.lon],[userLat,userLon])
    const distanceArray=element.distance.split('-')
    const mesure=distanceArray[1]==="متر"?1:1000
    element.distanceNumber=parseFloat(distanceArray[0])*mesure
  })
  dataList.sort((a,b)=>b.distanceNumber-a.distanceNumber)
  dataList.sort((a,b)=>{ 
    return a.working_hours.open==='1'?-1:1
  })

  if (props.splice) {
    SpliceChecker = dataList.slice(0, 3); 
  }
  if (!props.splice) {
    SpliceChecker = dataList;
  }
  return (
    <ul className={Style.ListHolder}>
      {SpliceChecker.filter((value) => {
        if (props.searchInput === "") {
          return value;
        } else if (props.searchInput === "باز") {
          return value.working_hours.open === "1";
        } else if (props.searchInput === "بسته") {
          return value.working_hours.open === 0;
        } else if (
          value.name
            .split(" ")
            .join("")
            .includes(props.searchInput.split(" ").join(""))
        ) {
          return value;
        }
        return false
      }).map((item) => {
        return (
          <Link
          style={{width:"100%"}}
            key={item.id}
            to={{
              pathname:
                item.working_hours.open === "1"
                  ? `/supplier/${item.id}/`
                  :`/storeClosed/${item.id}`,
              state: item,
            }}
          >
            <li className={Style.StoreInfo}>
              <div className={Style.ImageHolder}>
                <img
                  src={`//cdn.barest.ir/supplier/logo/${item.logo}.jpg`}
                  alt="رستوران"
                />
              </div>
              <div className={Style.StoreInfoHolder}>
                <h4 className={Style.StoreNameHolder}>{item.name}</h4>
                {
                  faildAddress?<h4 className={Style.Condition}>فاصله تقریبی : {item.distance}</h4>:null
                }
                <p className={Style.Condition}>
                  {" "}
                  وضعیت:{" "}
                  {item.working_hours.open === "1" ? (
                    <span className={Style.openCheck}>باز</span>
                  ) : (
                    <span>بسته</span>
                  )}
                </p>
                <div className={Style.StoreRate}>
                  <div className={Style.FixRate}>
                    <div className={Style.RateHolder}>
                      <div className={Style.grayStar}>
                        <FontAwesomeIcon icon={faStar} />
                        <FontAwesomeIcon icon={faStar} />
                        <FontAwesomeIcon icon={faStar} />
                        <FontAwesomeIcon icon={faStar} />
                        <FontAwesomeIcon icon={faStar} />
                      </div>
                      <div
                        className={Style.GoldStar}
                        style={{ width: `${item.supplier_rate * 20}%` }}
                      >
                        <div className={Style.GoldStarHolder}>
                          <FontAwesomeIcon icon={faStar} />
                          <FontAwesomeIcon icon={faStar} />
                          <FontAwesomeIcon icon={faStar} />
                          <FontAwesomeIcon icon={faStar} />
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </Link>
        );
      })}
    </ul>
  );
};

export default StoreList;
